import { Icon, IconProps } from './Icon';

export const ExchangeIcon = ({ color = 'currentColor', ...props }: IconProps) => (
  <Icon
    {...props}
    viewBox="0 0 24 24"
  >
    <path
      d="M19.6715 5.59282C18.2458 3.8837 16.2905 2.6993 14.1154 2.22733C11.9403 1.75536 9.6699 2.02284 7.66405 2.98735C5.6582 3.95187 4.03163 5.55826 3.04214 7.55191C2.05265 9.54556 1.75686 11.8124 2.20163 13.9932M21.728 9.69907C22.2529 11.9138 22.0062 14.2413 21.0288 16.2968C20.0513 18.3524 18.4016 20.0127 16.3525 21.0034C14.3033 21.9941 11.9774 22.2558 9.75935 21.7452C7.54129 21.2347 5.56389 19.9824 4.15413 18.1954"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M20.1623 3.33594V6.00147H17.4968M6.50147 17.9963H3.83594V20.6619"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M11.999 6.66797V17.3301"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M14.4109 9.53664C14.251 8.83028 13.3407 8.04395 12.0066 8.04395C10.6725 8.04395 9.64764 8.91024 9.64764 10.0031C9.64764 12.4874 14.5935 11.2106 14.5935 14.0947C14.5935 15.1356 13.3407 16.0192 12.008 16.0192C10.6752 16.0192 9.75027 15.1996 9.47705 14.3213"
      stroke={color}
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
